/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { useDocumentTitleContext } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useTranslation } from 'react-i18next';
import { Navbar } from 'reactstrap';
import 'scss/Main.scss';
import './NavMenu.scss';

export default function NavMenu() {
    const { i18n } = useTranslation();
    const { settings, appVersion } = useGeneralSettingsContext();
    const { pageTitle } = useDocumentTitleContext();

    const environment = settings
        .find((x) => x.code === 'InstanceEnvironment')
        ?.translations.find((x) => x.cultureCode === i18n.language)?.value;

    return (
        <Navbar className="nav-menu" light fixed="top" data-testid="nav-menu">
            <h5 className="nav-menu__header text-ellipsis">
                {environment
                    ? `${pageTitle} - ${environment} v ${appVersion}`
                    : `${pageTitle} - v ${appVersion}`}
            </h5>
            <div className="flex-grow-1"></div>
        </Navbar>
    );
}
